// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Numeral = require("../../../utils/Numeral.bs.js");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Belt_Option = require("@rescript/runtime/lib/js/Belt_Option.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function opt_of_string(value) {
  if (value !== "") {
    return value;
  }
}

function string_of_opt(value) {
  return Stdlib_Option.getOr(value, "");
}

function stripNonDigits(s) {
  return s.replace(/\D/g, "");
}

function preventDefault(f, e) {
  e.preventDefault();
  return f();
}

function eventValue(evt) {
  return evt.target.value;
}

function addHttp(value) {
  let httpRegEx = /^(?:f|ht)tps?:\/\//;
  if (value === "") {
    return "";
  } else if (httpRegEx.test(value)) {
    return value;
  } else {
    return `https://` + value;
  }
}

function formatAsPhone(value) {
  let value$1 = value.replace(/\D/g, "");
  if (value$1.length === 0) {
    return "";
  }
  let first = value$1.substring(0, 3);
  let middle = value$1.substring(3, 6);
  let last = value$1.substring(6, 10);
  if (value$1.length > 6) {
    return `(` + first + `) ` + middle + ` - ` + last;
  } else if (value$1.length > 3) {
    return `(` + first + `) ` + middle;
  } else {
    return `(` + first;
  }
}

function intFromFormattedPrice(event) {
  return Stdlib_Int.fromString(stripNonDigits(event.target.value), undefined);
}

function intOptToFormattedPrice(v) {
  return Stdlib_Option.getOr(Stdlib_Option.map(v, v => Numeral.format("FormPrice", v)), "");
}

function noneIfEmpty(str) {
  let match = Stdlib_Option.map(str, s => s.trim());
  if (match !== undefined && match !== "") {
    return str;
  }
}

function resultToStatus(s) {
  if (s !== undefined) {
    if (s.TAG === "Ok") {
      return "ok";
    } else {
      return "error";
    }
  }
}

function resultAsyncToStatus(s) {
  return Belt_Option.flatMap(s, x => {
    if (x.TAG === "Validating") {
      return;
    } else if (x._0.TAG === "Ok") {
      return "ok";
    } else {
      return "error";
    }
  });
}

exports.opt_of_string = opt_of_string;
exports.string_of_opt = string_of_opt;
exports.stripNonDigits = stripNonDigits;
exports.preventDefault = preventDefault;
exports.eventValue = eventValue;
exports.addHttp = addHttp;
exports.formatAsPhone = formatAsPhone;
exports.intFromFormattedPrice = intFromFormattedPrice;
exports.intOptToFormattedPrice = intOptToFormattedPrice;
exports.noneIfEmpty = noneIfEmpty;
exports.resultToStatus = resultToStatus;
exports.resultAsyncToStatus = resultAsyncToStatus;
/* Numeral Not a pure module */
